import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const useQueryParams = () => {
  const [queryParams, setQueryParams] = useState<{ [key: string]: string }>({});
  const { search } = useLocation();

  useEffect(() => {
    const parseQueryString = (queryString: string) => {
      const params = new URLSearchParams(queryString);
      const result: { [key: string]: string } = {};
      params.forEach((value, key) => {
        result[key] = value;
      });
      return result;
    };

    const parsedParams = parseQueryString(search);

    setQueryParams(parsedParams);
  }, []);

  return queryParams;
};

export default useQueryParams;
